module.exports = __webpack_public_path__ + "static/media/YF04_1.06288240.jpg";